import { render, staticRenderFns } from "./pdropquestion.vue?vue&type=template&id=1d0d4f7a&scoped=true&"
import script from "./pdropquestion.vue?vue&type=script&lang=js&"
export * from "./pdropquestion.vue?vue&type=script&lang=js&"
import style0 from "./pdropquestion.vue?vue&type=style&index=0&id=1d0d4f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d4f7a",
  null
  
)

export default component.exports